module.exports = __webpack_public_path__ + "static/maps-section-cloud-bg-9732f74a46d20621fdf06ea894d8f0fb.png";